<!-- 顶部弹出单选SELECT筛选 -->
<template>
  <van-popup v-model:show="isVisitPopup" @click-overlay="closePopup" position="top">
    <div class="ml_single_top">
      <div class="ml_single_top_list">
        <div class="ml_single_top_item" :class="{ 'ml_single_top_item_active': modelValue == item.gridType }"
          v-for="(item, index) in list" :key="index" @click.stop="onClickItem(item)">
            {{ item.gridName }}
        </div>
      </div>
    </div>
  </van-popup>

</template>

<script>
export default {
  name: "component-popup-single-top",
  data() {
    return {
      dataIndex: "",
      isVisitPopup: false
    };
  },
  props: {
    modelValue: null,
    list: {
      type: Array,
      value: [],
    },
  },
  methods: {
    openPopup() {
      // 打开弹窗
      this.isVisitPopup = true;
    },
    closePopup() {
      // 关闭弹窗
      this.isVisitPopup = false;
    },
    onClickItem(e) {
      this.closePopup();
      this.$emit("change", e);
    },
  }
}
</script>

<style lang="scss" scoped>
.ml_single_top {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100vw;

  .ml_single_top_list {
    background-color: #FFFFFF;
    border-radius: 0 0 16px 16px;
    padding: 0 20px;
    max-height: 80vh;
    overflow-y: auto;

    .ml_single_top_item {
      padding: 15px 0;
      border-bottom: 1px solid rgba($color: #E9E9E9, $alpha: 0.3);
      color: #292D33;

      &:last-child {
        border-bottom: 0;
      }
    }

    .ml_single_top_item_active {
      color: #327FFF;
      background: url('../assets/60.png') no-repeat center right;
      background-size: 25px 25px;
    }
  }
}
</style>
